import { lazy } from "react"

export const Offers = lazy(() => import("@/views/offers/Offer"))
export const OffersDataGrid = lazy(() => import("components/offersDataGrid/OffersDataGrid"))
export const OfferDataTable = lazy(() => import("components/offerDataTable/OfferDataTable"))
export const PlanFormModal = lazy(() => import("@/views/offers/components/PlanFormModal"))
export const AddOffer = lazy(()=> import("@/views/offers/AddOffer"))